<template>
  <div class="base-table" style="background: white;border-radius: 15px;">
    <!-- 表格上方操作栏 ，插槽actionBar，配置操作按钮-->
    <el-table
      :span-method="spanMethod || arraySpanMethod"
      v-loading="loading"
      :element-loading-text="$t('tips.loading')"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.8)"
      :row-class-name="stripe ? tabRowClassName : ''"
      :cell-class-name="mergeCells ? handleCellClassName : ''"
      @selection-change="handleCustomSelect"
      @sort-change="sortChange"
      ref="table"
      :row-key="rowKey"
      :border="border"
      :height="height"
      :max-height="maxHeight"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      :data="tableData"
      style="width: 100%;border-radius: 15px; border: solid 1px #E5E8EF;"
      :class="{ typeTable: isSingle, 'empty-table': tableData.length === 0 }"
    >

      <!-- <el-table-column v-if="selection" align="center" type="selection" :selectable="selectable" width="55"> </el-table-column> -->

      <!-- 表格最前面列的插槽 -->
      <slot name="firstColumn"></slot>

      <el-table-column
        v-for="item of labelData"
        :min-width="item.minWidth"
        :width="item.width"
        :label="item.label"
        :fixed="item.fixed"
        :align="item.align || 'left'"
        :prop="item.prop"
        :sortable="item.sortable"
        :key="item.label"
      >
        <template #header>
          <div v-if="item.headerTip" class="header-tip-wrapper">
            <BaseTooltip :text="item.label"></BaseTooltip>
            <el-tooltip class="item" effect="dark" placement="right-start">
              <div slot="content">
                {{ item.headerTip }}
              </div>
              <i class="iconfont icon-jieshi-xian question-icon"></i>
            </el-tooltip>
          </div>
          <BaseTooltip v-else :text="item.label"></BaseTooltip>
        </template>
        <template slot-scope="scope">
          <template v-if="item.isCopy">
            <div v-if="scope.row[item.prop]" class="copy-wrapper">
              <div class="copy-content">
                <BaseTooltip :line-number="lineNumber" :text="scope.row[item.prop]"></BaseTooltip>
              </div>
              <i class="iconfont icon-fuzhi text-light-muted" :id="item.prop" :data-clipboard-text="scope.row[item.prop]" v-copy="item.prop"></i>
            </div>
            <span v-else>－</span>
          </template>
          <BaseTooltip v-else :line-number="lineNumber" :text="item.formatter ? item.formatter(scope.row) : handleFormatter(scope.row, item)"> </BaseTooltip>
        </template>
      </el-table-column>

      <!-- 表格最后面列的插槽 -->
      <slot></slot>

      <template slot="empty">
        <BaseEmptyView></BaseEmptyView>
      </template>
    </el-table>
    <div v-if="showPagination && counts > 0" class="table-pagination">
      <el-pagination
        background
        @size-change="handleSelectionChange"
        @current-change="getCurrentPage"
        layout="prev, pager, next"
        :page-sizes="pageSizeArr"
        :page-size="pageSize"
        :current-page="currentPage"
        :total="counts"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getUTCToLocalTime } from '@/utils/util'
import BaseEmptyView from './BaseEmptyView.vue'

export default {
  name: 'baseTable',
  components: {
    BaseEmptyView
  },
  props: {
    rowKey: {
      type: String,
      default: 'id'
    },
    height: {
      type: Number
    },
    maxHeight: {
      type: Number
    },
    stripe: {
      type: Boolean,
      default: true
    },
    loading: Boolean,
    tableData: Array,
    labelData: Array,
    rowSpanArr: Array,
    showPagination: {
      type: Boolean,
      default: true
    },
    counts: Number,
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: Number,
    selection: Boolean,
    isSingle: Boolean,
    border: {
      type: Boolean,
      default: false
    },
    merge: {
      type: Boolean,
      default: false
    },
    mergeCellsIndexes: {
      type: Array,
      default: () => []
    },
    mergeCells: {
      type: Boolean,
      default: false
    },
    lineNumber: {
      type: Number,
      default: 2
    },
    spanMethod: {
      type: Function
    },
    selectable: {
      type: Function
    }
  },
  data() {
    return {
      pageSizeArr: [10, 15, 20, 30, 60]
    }
  },
  created() {},
  methods: {
    /**
     * @description: 合并行或列的计算方法
     * @param {*} row 当前行
     * @param {*} column 当前列
     * @param {*} rowIndex 当前行号
     * @param {*} columnIndex 当前列号
     */
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.merge) {
        // 只合并区域位置
        if (columnIndex === 0) {
          const _row = this.rowSpanArr[rowIndex]
          return {
            rowspan: _row, // 行
            colspan: 1 // 列
          }
        }
      }
      if (this.mergeCells) {
        if (this.mergeCellsIndexes.includes(columnIndex)) {
          const _row = this.rowSpanArr[rowIndex]
          const _col = _row > 0 ? 1 : 0

          return {
            rowspan: _row,
            colspan: _col
          }
        }
      }
    },
    clearSelection() {
      this.$refs.table.clearSelection()
    },
    /**
     * @description: 用于多选表格，切换某一行的选中状态，如果使用了第二个参数，则是设置这一行选中与否
     * @param {*} row 当前行
     */
    handleCustomSelect(val) {
      if (val.length > 1 && this.isSingle) {
        this.$refs.table.clearSelection()
        this.$refs.table.toggleRowSelection(val.pop())
      }
      this.$emit('selection-change', val)
      // this.$refs.table.toggleRowSelection(row)
    },
    sortChange(e) {
      this.$emit('sort-change', e)
    },
    /**
     * @description: 通过方法计算返回对应class样式
     * @param {*} row 当前行
     * @param {*} rowIndex 当前行号
     * @return {Boolen}
     */
    tabRowClassName({ row, rowIndex }) {
      if (this.mergeCells) {
        if (!row.isOdd) {
          return 'warning-row'
        }
        return
      }

      if (rowIndex % 2 === 0) {
        return 'warning-row'
      }
    },
    handleCellClassName({ row, column, rowIndex, columnIndex }) {
      if (!this.mergeCellsIndexes.includes(columnIndex)) {
        // 合并列时，去掉行之间的下划线
        let className = ''
        if (row.noBorderBottom) {
          className += 'no-border-bottom '
        }

        // 合并列时, 去掉第一列的左内边距
        if (row.noPadding) {
          className += 'td-no-padding'
        }

        return className
      }
    },
    /**
     * @description: currentPage 改变时会触发
     * @param {*} index 跳转页码
     * @return {*}
     */
    getCurrentPage(index) {
      this.$emit('page-change', index)
    },
    /**
     * @description: pageSize 改变时会触发
     * @param {*} val  每页条数
     * @return {*}
     */
    handleSelectionChange(val) {
      this.$emit('size-change', val)
    },
    handleFormatter(row, item) {
      if (item.isDatetime) {
        return getUTCToLocalTime(row[item.prop])
      } else {
        return row[item.prop]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';

.base-table {
  border-radius: 4px;
  padding: 20px 20px 0 20px;
  .copy-wrapper {
    display: flex;
    align-items: center;
    width: 100%;

    .copy-content {
      flex: 1;
      margin-right: 8px;
    }
  }
  .header-tip-wrapper {
    display: flex;
    align-items: center;
    .question-icon {
      font-weight: normal;
      margin-left: 4px;
      color: #8b8e9a;
      font-size: 14px;
    }
  }

  .empty-table {
    &::before {
      display: none;
    }
  }

  /deep/ .el-table__fixed::before,
  /deep/ .el-table__fixed-right::before {
    display: none;
  }

  /deep/ .el-pagination {
    font-weight: 400;
    // lxl-未选中按钮背景
    .el-pager li:not(.active){
      background: white;
      border: 1px solid #E5E8EF;
    }
    //上下页
    .btn-prev {
      background: none !important;
      border: none !important;
    }
    .btn-next {
      background: none !important;
      border: none !important;
    }
  }

  .table-pagination {
    // margin: 20px 40px 0 0;
    padding: 20px 0;
    display: flex;
    // lxl-翻页修改
    justify-content: flex-end;
    // justify-content: flex-start;
  }

  .cell-word {
    cursor: pointer;
  }

  /deep/ .el-table {

  thead {
    // color: #fff;
    color: #1D2129 !important;
    font-weight: 500;
    // background: linear-gradient(to right, #74a5f9, #4cdafe) !important;
    background: #E5E8EF !important;

    & th {
      background-color: transparent;
    }

    & tr {
      background-color: transparent;
    }
  }


    .el-table__cell.is-center .cell {
      justify-content: center;
    }

    .el-table__header {
      tr {
        th:first-of-type {
          padding-left: 32px;
        }
        th.last-column,
        th:not(.gutter):last-of-type {
          padding-right: 32px;
        }
      }

      .el-table__cell {
        padding: 0;
        // border-bottom: 1px solid $base-line-1;

        .cell {
          display: flex;
          align-items: center;
          height: 50px;
          // line-height: 16px;
          line-height: 18px;
          // color: #fff;
          color: #1D2129; 
          // color: $base-text-primary;
          font-weight: 500;
          font-size: 16px;
          // font-size: 14px;
          word-break: break-word;
        }
      }
    }

    .el-table__body {
      .warning-row {
        // lxl-table行背景颜色
        // background-color: #ecf6f8;
      }

      .no-border-bottom {
        border-bottom: none;
      }

      .td-no-padding:first-of-type {
        padding: 0;
      }

      .td-no-padding:not(.gutter):last-of-type {
        padding-right: 0;
      }

      tr {
        td {
          border-bottom: 1px solid $base-line-2;
          padding: 0;
        }

        td:first-of-type {
          padding-left: 32px;
        }

        td:not(.gutter):last-of-type {
          padding-right: 32px;
        }

        .cell {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          min-height: 48px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-word;
          line-height: 16px;
          padding: 8px 12px;
          color: #868D9C;
          font-weight: 400;
          .el-switch {
            height: 16px;
            line-height: 16px;

            &.is-checked .el-switch__core::after {
              margin-left: -13px;
            }

            .el-switch__core {
              width: 32px !important;
              height: 16px;
              border-radius: 8px;

              &::after {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
      }
    }
  }

  // 操作栏样式
  /deep/ .actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &:last-child {
      margin-right: 0;
    }
  }

  /deep/ .oppbtn {
    border: 0px none;
    color: $base-brand;
    cursor: pointer;
    font-size: 14px;
    padding: 0;
    background-color: rgba(255, 255, 255, 0);
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;

    a {
      font-size: 12px;
      font-weight: normal;
    }
  }

  /deep/ .oppbtn:hover {
    border: none;
    text-decoration: underline;
    background-color: rgba(255, 255, 255, 0);
  }

  /deep/ .oppbtn:focus {
    outline: none;
    background-color: rgba(255, 255, 255, 0);
  }

  /deep/.el-table {
    .cell {
      .el-button {
        margin-bottom: 4px;
        margin-left: 4px;
      }
    }
  }

  /deep/ .copy {
    position: relative;
    cursor: pointer;

    i {
      position: absolute;
      right: 0;
      top: 50%;
      font-size: 14px;
      transform: translateY(-50%);
    }
  }

  .spans {
    margin: 0 6px;
    display: inline-block;
    cursor: pointer;
  }
}

.typeTable {
  /deep/ .el-table__header-wrapper {
    .el-table-column--selection {
      .el-checkbox {
        display: none !important;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/baseTable.vue